/*
@创建人: lfq
@创建时间: 2020-10-23 09:57:51
@文件介绍: 防护设施决策
*/
export default [{
    path: 'sideSlopeMpm',
    name: 'sideSlopeMpm',
    meta: {
        title: '防护设施规划管理',
        auth: true
    },
    component: () =>
        import ('@/views/sideSlopeDecision/sideSlopeMpm')
},{
    path: 'sideSlopeMfp',
    name: 'sideSlopeMfp',
    meta: {
        title: '防护设施养护资金规划',
        auth: true
    },
    component: () =>
        import ('@/views/sideSlopeDecision/sideSlopeMfp')
},{
    path: 'sideSlopeMp',
    name: 'sideSlopeMp',
    meta: {
        title: '防护设施养护规划',
        auth: true
    },
    component: () =>
        import ('@/views/sideSlopeDecision/sideSlopeMp')
}]